<template>
	<v-row
		align='center'
		class='px-4 py-7'
		justify='center'
		style='height: 100%'
	>
		<div class='text-center'>
			<v-progress-circular
				:size='66'
				:width='5'
				color='accent'
				indeterminate
			/>
			<div class='mt-3 font-weight-bold' style='font-size: 17px'>
				{{ text }}
			</div>
		</div>
	</v-row>
</template>

<script>
	export default {
		name: 'LoadingSpinner',
		props: {
			text: {
				type: String,
				default: 'Lädt, bitte warten...'
			}
		}
	}
</script>
